import pTimeout from "p-timeout";
import { segmentAnalyticsInstance } from "@/domains/metrics/segment-analytics-instance";
import { logger } from "@/modules/logger";
import { objectModule } from "@/modules/object";

const SEGMENT_TIMEOUT_MS = 2000;

export const resolveSegmentAnonymousId = async (): Promise<string | null> => {
  try {
    const user = await pTimeout(segmentAnalyticsInstance().user(), {
      milliseconds: SEGMENT_TIMEOUT_MS,
      fallback: () => {
        logger.warn({
          message: "[resolveSegmentAnonymousId] Timed out resolving Segment anonymous id.",
        });
        return null;
      },
    });
    return user?.anonymousId() ?? null;
  } catch (unknownErr) {
    const err = unknownErr as Error;

    logger.warn({
      message: "[resolveSegmentAnonymousId] Failed to read Segment anonymous id.",
      info: { error: objectModule.safeErrorAsJson(err) },
    });

    return null;
  }
};
